// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:36:08.327Z
// Property: The Courtyards (ID: 6767906449165633)
// Collections: 23 amenities, 8 floorplans (live), 38 photos, 76 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165633",
  "property_external_id": "br8v4kb",
  "property_zillow_url": "https://www.zillow.com/b/the-courtyards-tulsa-ok-5XhzRQ/",
  "property_apartments_url": "https://www.apartments.com/the-courtyards-tulsa-ok/br8v4kb/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Courtyards/data=!4m2!3m1!1s0x0:0xfa572219ea20e67d?sa=X&ved=2ahUKEwjF7IbugL2SAxUMtokEHcAELYcQ_BJ6BAgQEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-courtyards",
  "property_name": "The Courtyards",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/the-courtyards/",
  "property_domain": null,
  "property_address": "6748 E. 91st Street",
  "property_full_address": "6748 E. 91st Street, Tulsa, OK, 74133",
  "property_address_1": "6748 E. 91st Street",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74133",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0304",
  "property_address_longitude": "-95.901",
  "property_email": "courtyards@caseusa.com",
  "property_phone": "(539) 265-2726",
  "property_call_tracking_phone": "833-293-1994",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At The Courtyards in Tulsa, your ideal home awaits with spacious one and two-bedroom layouts. Enjoy resort-style amenities—swim in the refreshing pool, stay fit in the gym, or unwind at the inviting clubhouse. With picturesque walking trails and each unit designed for comfort, the perfect lifestyle is just a visit away! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Welcome to The Courtyards, Your Premier Apartment Community in Tulsa, Oklahoma!**\n\nDiscover your perfect living space at The Courtyards, where comfort meets convenience in our thoughtfully designed one and two-bedroom apartments. Each home is equipped with modern amenities including air conditioning, high-speed internet access, and in-unit washers/dryers, providing you with the ultimate in everyday comfort. \n\nStep outside your door and enjoy our exceptional community amenities. Take a refreshing dip in our inviting pool, stay fit in our fully-equipped fitness center, or unwind in the cozy clubhouse after a long day. For those who love the outdoors, our beautifully landscaped courtyard, walking and biking trails, picnic area, and grilling stations offer the perfect setting for relaxation and recreation. \n\nAt The Courtyards, you will appreciate the convenience of on-site maintenance and a dedicated property manager, ensuring your needs are met promptly. Our smoke-free community offers various features such as ceiling fans, fireplaces, and ample window coverings, creating a serene and stylish atmosphere for you to call home.\n\nLocated in the vibrant city of Tulsa, The Courtyards positions you within easy reach of shopping, dining, and entertainment. With options to view all our available floor plans, you’ll be sure to find a home that fits your lifestyle.\n\nDon't wait—find your new home today at The Courtyards! Browse our availability or schedule a tour to explore all that our community has to offer. Your ideal apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-a863-768d-94ea-6f3a63b32d71.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with parking lot and cars.",
    "public_id": "019cfb4a-a863-768d-94ea-6f3a63b32d71",
    "storage_key": "property/6767906449165633/019cfb4a-a863-768d-94ea-6f3a63b32d71.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "272",
  "property_year_built": "1986",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.52941176470588",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Cats and dogs are allowed with no weight limit, maximum of two pets per unit, subject to management approval.",
  "property_pet_policy_description": "We welcome cats and dogs with no weight limit. Pets are subject to management approval. Maximum of two pets per unit. One-time pet fee: $500 per pet. Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://courtyardsapartmentstulsa.securecafe.com/onlineleasing/the-courtyards/floorplans.aspx",
  "property_resident_portal_url": "https://courtyardsapartmentstulsa.securecafe.com/residentservices/the-courtyards/userlogin.aspx",
  "property_apply_now_url": "https://courtyardsapartmentstulsa.securecafe.com/onlineleasing/the-courtyards/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-a807-7209-9b25-66d6350ad8fa.webp",
  "property_primary_logo_media": {
    "alt_text": "The Courtyards of Tulsa logo",
    "public_id": "019cfb49-a807-7209-9b25-66d6350ad8fa",
    "storage_key": "property/6767906449165633/019cfb49-a807-7209-9b25-66d6350ad8fa.webp",
    "width": 400,
    "height": 100
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-9dd9-723f-a770-83d1d56d5739.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb4a-9dd9-723f-a770-83d1d56d5739",
    "storage_key": "property/6767906449165633/019cfb4a-9dd9-723f-a770-83d1d56d5739.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-b8be-778e-90a4-c926734b6a51.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Courtyards of Tulsa logo",
    "public_id": "019cfb4a-b8be-778e-90a4-c926734b6a51",
    "storage_key": "property/6767906449165633/019cfb4a-b8be-778e-90a4-c926734b6a51.webp",
    "width": 400,
    "height": 100
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-c7f8-73a4-97e8-ee7b43b6acba.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Courtyards of Tulsa logo",
    "public_id": "019cfb4a-c7f8-73a4-97e8-ee7b43b6acba",
    "storage_key": "property/6767906449165633/019cfb4a-c7f8-73a4-97e8-ee7b43b6acba.webp",
    "width": 400,
    "height": 100
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#283849",
  "property_secondary_color": "#a6a8ab",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#a79f92",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "700 - 1029",
  "property_sqft_min": "700",
  "property_sqft_max": "1029",
  "property_price_range": "1014 - 1354",
  "property_price_min": "1014",
  "property_price_max": "1354",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/CourtyardsTulsa/photos/",
  "property_instagram_url": "https://www.instagram.com/courtyardsoftulsa/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJfyRNLACStocRfeYg6hkiV_o",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-courtyards-on-st-louis-tulsa",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Courtyards",
  "property_home_romance_title": "Embrace Comfort and Style in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to The Courtyards in Tulsa, where comfort meets convenience! Choose from spacious one- and two-bedroom floor plans, and enjoy luxurious amenities like a refreshing pool, modern fitness center, cozy clubhouse, and scenic walking trails. Discover your perfect oasis today, complete with all the comforts of home!",
  "property_home_floorplans_blurb": "Welcome to The Courtyards in Tulsa, Oklahoma, where comfort meets style. Choose from our thoughtfully designed one and two-bedroom apartments, tailored to suit your lifestyle. Start your journey today by browsing our available homes and uncovering the ideal floor plan that fits your unique needs. Your perfect apartment awaits!",
  "property_home_gallery_blurb": "At The Courtyards in Tulsa, Oklahoma, elevate your lifestyle with spacious one- and two-bedroom floor plans designed for comfort. Enjoy a refreshing swim in the pool, energize in the fitness center, or unwind in the picturesque courtyard. Picture yourself living here, where modern amenities harmonize with scenic views!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Tulsa, The Courtyards invites you to experience vibrant living with spacious one and two-bedroom floor plans. Immerse yourself in the local culture and everyday conveniences—uncover charming favorites and key attractions just steps from your doorstep. Immerse yourself in our thriving neighborhood today! ",
  "property_home_reviews_blurb": "At The Courtyards in Tulsa, Oklahoma, residents rave about the \"welcoming community and stunning landscapes\" that make it feel like home. Join a vibrant lifestyle surrounded by beautiful amenities and friendly neighbors. See what our residents have to say about living at our community—your ideal home awaits!",
  "property_neighborhood_blurb": "At The Courtyards in Tulsa, Oklahoma, you'll find a thriving blend of educational excellence and community spirit. Just moments away from prestigious institutions like Oral Roberts University and Regent Preparatory School, our apartment community seamlessly connects you to top-notch schools and vibrant local spots. Uncover the charm of your new neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to The Courtyards in Tulsa, where comfort meets convenience. Choose from spacious one- or two-bedroom apartments equipped with modern amenities like in-unit washer/dryers and high-speed internet. Enjoy sunny days at our pool, unwind in the clubhouse, or stroll through scenic walking trails. Your ideal lifestyle awaits!",
  "property_applynow_blurb": "Embrace a life of comfort at The Courtyards in Tulsa, where stylish one- and two-bedroom apartments meet exceptional amenities. Dive into our inviting pool, unwind in the clubhouse, or take a stroll along scenic walking trails. Ready to elevate your lifestyle? Lease your new home online today!",
  "property_contactus_blurb": "At The Courtyards in Tulsa, Oklahoma, your new home awaits with thoughtfully designed one and two-bedroom floor plans tailored for modern living. Embrace comfort and style in a welcoming community. For inquiries or more information, reach out to our leasing team today—let us help you find your perfect space!",
  "property_faqs_blurb": "At The Courtyards in Tulsa, Oklahoma, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Dive into our FAQs page for insights on community features and amenities that make living here exceptional. Your perfect home awaits—answer your questions today!",
  "property_floorplans_blurb": "At The Courtyards in Tulsa, Oklahoma, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Each space combines comfort and style, ensuring you feel right at home. Browse our available apartment homes today and find the perfect layout that suits your needs!",
  "property_gallery_blurb": "At The Courtyards in Tulsa, Oklahoma, envision life surrounded by stunning amenities—lounge by the pool, energize in the fitness center, or unwind in the tranquil courtyard. With stylish one and two-bedroom floor plans and outdoor spaces to enjoy, this smoke-free oasis is waiting for you! Picture yourself living here!",
  "property_interactivemap_blurb": "Nestled in the heart of Tulsa, The Courtyards offers spacious one- and two-bedroom apartments paired with top-notch amenities. Enjoy sunny days at the pool or invigorating workouts in the fitness center. Unwind in our inviting clubhouse or explore scenic walking trails. Ready to make it yours? Check out our interactive community map!",
  "property_pets_blurb": "At The Courtyards in Tulsa, OK, your furry friends are embraced with open arms! With no weight limits and ample space for you and your pets, indulge in a community that understands the value of companionship. Enjoy pet-friendly living with a one-time fee and affordable monthly rent.",
  "property_referafriend_blurb": "At The Courtyards in Tulsa, Oklahoma, our vibrant community thrives on connections. Whether you prefer a cozy one-bedroom or need space in a two-bedroom, we have the perfect floor plan for you. Great friends make great neighbors—refer a friend to share in our exceptional living experience today!",
  "property_residentaccess_blurb": "Welcome to The Courtyards in Tulsa, Oklahoma, where comfort meets convenience. Whether you prefer a cozy one-bedroom retreat or a spacious two-bedroom haven, our diverse floor plans cater to your lifestyle. Access your resident portal now to effortlessly pay rent, schedule maintenance, and enjoy a seamless living experience.",
  "property_reviews_blurb": "At The Courtyards in Tulsa, residents rave about the \"welcoming atmosphere and attentive staff.\" With a vibrant community and modern amenities, it's not just a place to live; it's a lifestyle. See what our residents have to say about living at our community! Your perfect home awaits!",
  "property_created_at": "1753982394081",
  "property_scheduletour_blurb": "At The Courtyards in Tulsa, Oklahoma, we offer thoughtfully designed one and two-bedroom apartments that cater to every lifestyle. Each floor plan radiates comfort and style, perfect for creating lasting memories. Schedule a tour today and find out why our residents love calling The Courtyards home!",
  "property_thankyou_blurb": "Thank you for reaching out to The Courtyards in vibrant Tulsa, Oklahoma! Our selection of thoughtfully designed one and two-bedroom floor plans awaits your discovery. Stay tuned—our team will connect soon to help you find your perfect home in our welcoming community. Your next chapter starts here!",
  "property_virtualtours_blurb": "Welcome to The Courtyards in Tulsa, Oklahoma, where comfort meets style. Our thoughtfully designed one and two-bedroom apartments offer the perfect blend of space and sophistication. Ready to envision your new home? Take a virtual tour today and experience the charm and convenience of our vibrant community!",
  "property_copyright": "2025 All Rights Reserved. The Courtyards",
  "property_seo_title_home": "The Courtyards | Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Experience modern living at The Courtyards in Tulsa! Choose from stylish one and two-bedroom apartments with top-notch amenities and serene outdoor spaces.",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Tulsa, Oklahoma",
  "property_seo_description_floorplans": "Find your perfect space at The Courtyards in Tulsa! Check out our unique one and two-bedroom floor plans tailored for your lifestyle. ",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort and luxury at The Courtyards in Tulsa! Enjoy a pool, fitness center, clubhouse, and more. Your perfect home awaits—check out our amenities!",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "\"Picture life at The Courtyards in Tulsa—luxurious amenities, serene trails, and cozy homes await you. Dive into our photo gallery and envision your new haven!\"",
  "property_seo_title_virtualtours": "Virtual Tours | The Courtyards Apartments",
  "property_seo_description_virtualtours": "Experience the charm of The Courtyards in Tulsa! Take a virtual tour of our inviting one and two-bedroom apartments and find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | The Courtyards Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Courtyards in Tulsa! Use our interactive map to explore one and two-bedroom apartments with top-notch amenities and scenic views.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of The Courtyards in Tulsa! Dive into local favorites and hidden gems just steps from your new home. Embrace vibrant community living today!",
  "property_seo_title_contact": "Contact Us | The Courtyards",
  "property_seo_description_contact": "Experience comfortable living at The Courtyards in Tulsa! Inquire about our stylish one and two-bedroom floor plans. Got questions? Reach out to our leasing team!",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "\"Find clarity at The Courtyards in Tulsa, OK! Our FAQs cover everything from floor plans to amenities. Get ready to elevate your living experience.\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "\"Join the vibrant community at The Courtyards in Tulsa! See resident reviews and learn why our spacious apartments and top-notch amenities make it home.\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Experience modern living at The Courtyards in Tulsa! Enjoy spacious one- and two-bedroom apartments with top-tier amenities, including a pool, fitness center, and scenic trails. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | The Courtyards",
  "property_seo_description_residentaccess": "Log in to The Courtyards' resident portal for seamless rent payments, quick maintenance requests, and exclusive community updates—all in one convenient place!",
  "property_seo_title_referafriend": "Refer A Friend | The Courtyards",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Courtyards in Tulsa and enjoy exclusive rewards in our vibrant community. Share the love today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Courtyards",
  "property_seo_description_scheduletour": "Experience the charm of The Courtyards in Tulsa! Schedule your tour today and envision your new life in a vibrant, welcoming community.",
  "property_seo_title_privacy": "Privacy Policy | The Courtyards",
  "property_seo_description_privacy": "At The Courtyards in Tulsa, we prioritize your privacy. Uncover how we protect your information—read our comprehensive privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Courtyards",
  "property_seo_description_accessibility": "Experience inclusive living at The Courtyards in Tulsa, where accessibility meets comfort. Join our community and embrace a lifestyle designed for everyone!",
  "property_seo_title_sitemap": "Sitemap | The Courtyards",
  "property_seo_description_sitemap": "Navigate your way to your new home at The Courtyards in Tulsa! Check out our sitemap for a sneak peek of our vibrant community and available amenities.",
  "property_seo_title_thankyou": "Thank You | The Courtyards",
  "property_seo_description_thankyou": "Thank you for reaching out to The Courtyards in Tulsa! We’ll connect soon to help you find your perfect home in our vibrant community. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865924475",
  "amenities": [
    {
      "id": "ec_7fd7787ac2d95488c0dde521",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127397264",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50f90d70d90a30adb59f3f33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127397265",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9156b35ced09457c01e41c1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127397266",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b31bed042a5614f48997d29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127397267",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3efd015cbe07b782b2963e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127397268",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6fd74ed6d8f9a015a90b6d38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127397269",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64ff0e2e541f7984591f4e56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127397271",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d24b889624956b367afcabe2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127397272",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0770b55212b93aec7f73c092",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "128017293",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d5b04f305c7cc8d981fa91f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "128042527",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6a36eb8a04d6de7143effe8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398729",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab61e6087983ed022ccc82ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398730",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3fd8ceb51d06b34aa74c05d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398731",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b114eac68ef734bc057fba0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398732",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e1d0f4492b1b6309f23e04f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398733",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6f705a474364eba619b20b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398734",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3046542f0a65630a73784ad6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398735",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_352dba2b18671d0214523b63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398736",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c30790cb3f7a45d355ddc3f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398737",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da709bf77d17ba43cf6b5e88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398738",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f2a9892174496a60419264c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398739",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fafb55b049fdfce3dd03f41a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398740",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_798b70910d8a8c7b5006cb3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "yardi",
      "external_id": "127398741",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_e386b943-47cc-4037-b243-d7feac308535",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5d87-77a3-9814-b2edf964512a.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building entrance with landscaping and signage.",
        "public_id": "019ee077-5d87-77a3-9814-b2edf964512a",
        "storage_key": "property/6767906449165633/019ee077-5d87-77a3-9814-b2edf964512a.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Welcome to our apartment community, featuring a beautifully landscaped entrance and building facade.",
      "link": "",
      "alt_text": "Exterior of apartment building entrance with landscaping and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f5de6a9-1a73-4d98-80c5-2bd2bdc70f3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5fa0-714d-98a3-f9300007e03f.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including a tunnel, weave poles, and jumps.",
        "public_id": "019ee077-5fa0-714d-98a3-f9300007e03f",
        "storage_key": "property/6767906449165633/019ee077-5fa0-714d-98a3-f9300007e03f.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, equipped with agility obstacles for your furry friend's enjoyment and exercise. Perfect for playtime and socialization.",
      "link": "",
      "alt_text": "Dog park with agility equipment including a tunnel, weave poles, and jumps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_adcc0875-3fc3-409b-89d4-eaab11fc894b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5d5b-727e-9e04-6e444f448b8b.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with tables and chairs under a wooden pergola, adjacent to apartment buildings.",
        "public_id": "019ee077-5d5b-727e-9e04-6e444f448b8b",
        "storage_key": "property/6767906449165633/019ee077-5d5b-727e-9e04-6e444f448b8b.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and relaxation in our community's outdoor seating area, complete with shaded tables and chairs under a charming pergola.",
      "link": "",
      "alt_text": "Outdoor seating area with tables and chairs under a wooden pergola, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_817756e5-2b0f-4825-b37c-0cd0a6222629",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5c55-73b0-a8cf-72b3eb8f7a5f.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas.",
        "public_id": "019ee077-5c55-73b0-a8cf-72b3eb8f7a5f",
        "storage_key": "property/6767906449165633/019ee077-5c55-73b0-a8cf-72b3eb8f7a5f.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Apartment complex swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a88095bf-e616-4fd5-aa9e-4320208fa3a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5d5f-722c-a8ed-b55dc2a9b135.webp",
      "image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019ee077-5d5f-722c-a8ed-b55dc2a9b135",
        "storage_key": "property/6767906449165633/019ee077-5d5f-722c-a8ed-b55dc2a9b135.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded areas for your enjoyment.",
      "link": "",
      "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_11d56206-9378-4183-92ec-3b5e825fb726",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee077-5b4c-7219-a98c-5d488263e0de.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019ee077-5b4c-7219-a98c-5d488263e0de",
        "storage_key": "property/6767906449165633/019ee077-5b4c-7219-a98c-5d488263e0de.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool and soak up the sun in comfortable lounge chairs. Enjoy the beautiful outdoor space at our community.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8e9899a6-1a33-433f-99dc-cf3dfb527590",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee076-e6bc-778a-b426-7b999ade8240.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and well-maintained landscaping.",
        "public_id": "019ee076-e6bc-778a-b426-7b999ade8240",
        "storage_key": "property/6767906449165633/019ee076-e6bc-778a-b426-7b999ade8240.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings featuring private balconies and lush green spaces, offering a comfortable and serene living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and well-maintained landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0da7bc47-e85e-4f65-8f14-b701df3efa93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee076-e3c4-71d3-a438-d7044a5d4e47.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured landscaping.",
        "public_id": "019ee076-e3c4-71d3-a438-d7044a5d4e47",
        "storage_key": "property/6767906449165633/019ee076-e3c4-71d3-a438-d7044a5d4e47.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Charming apartment exteriors with private balconies and lush greenery, creating a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35865ee2-e4d4-468b-925c-dfd574a08425",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee076-e4b1-777d-b9f8-72921a31ceff.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019ee076-e4b1-777d-b9f8-72921a31ceff",
        "storage_key": "property/6767906449165633/019ee076-e4b1-777d-b9f8-72921a31ceff.webp",
        "width": 1350,
        "height": 900
      },
      "title": "Community",
      "description": "Discover this spacious apartment community featuring a refreshing pool and lush green surroundings. Enjoy comfortable living in this well-maintained complex.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex with multiple buildings, a pool, and surrounding greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ab097f81-e462-445b-8b5f-d7e93d6dd7d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee070-d6c0-7792-b4ff-c39856df9d8a.webp",
      "image_media": {
        "alt_text": "Empty closet with wire shelving and two wicker baskets.",
        "public_id": "019ee070-d6c0-7792-b4ff-c39856df9d8a",
        "storage_key": "property/6767906449165633/019ee070-d6c0-7792-b4ff-c39856df9d8a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving and decorative baskets, perfect for organization.",
      "link": "",
      "alt_text": "Empty closet with wire shelving and two wicker baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_703372a5-9bfe-4aca-913c-6fe1f6c724d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee070-c67e-7459-8f35-7bd5cc32160e.webp",
      "image_media": {
        "alt_text": "White bathtub with a white shower curtain and a plant on the counter.",
        "public_id": "019ee070-c67e-7459-8f35-7bd5cc32160e",
        "storage_key": "property/6767906449165633/019ee070-c67e-7459-8f35-7bd5cc32160e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Clean and bright bathroom with a bathtub, shower, and decorative plant on the vanity.",
      "link": "",
      "alt_text": "White bathtub with a white shower curtain and a plant on the counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5ab6df43-171f-488e-8cb4-2a3c2e5f0b06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee070-c41a-723e-aa89-1ccb68e12f4e.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, toilet, and shower with white curtain.",
        "public_id": "019ee070-c41a-723e-aa89-1ccb68e12f4e",
        "storage_key": "property/6767906449165633/019ee070-c41a-723e-aa89-1ccb68e12f4e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and bright bathroom featuring a vanity with a granite-look countertop, a white sink, and wooden cabinets, a toilet, and a bathtub with a white shower curtain.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, toilet, and shower with white curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b6199345-ad6c-4b60-b933-921156164e26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee070-b1c7-77db-a106-bde4a9760503.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and window.",
        "public_id": "019ee070-b1c7-77db-a106-bde4a9760503",
        "storage_key": "property/6767906449165633/019ee070-b1c7-77db-a106-bde4a9760503.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and well-lit bedroom featuring a queen-size bed with decorative bedding, a modern nightstand with a lamp, and a dresser. Large windows with sheer curtains allow natural light to fill the room.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_49864c17-8dd1-4bf2-a940-286ade3443a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee070-9444-72cb-930a-00431961e37e.webp",
      "image_media": {
        "alt_text": "Staircase leading to apartment door with an arched window above",
        "public_id": "019ee070-9444-72cb-930a-00431961e37e",
        "storage_key": "property/6767906449165633/019ee070-9444-72cb-930a-00431961e37e.webp",
        "width": 2046,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Carpeted staircase leading up to an apartment entrance, illuminated by a light fixture and a decorative arched window.",
      "link": "",
      "alt_text": "Staircase leading to apartment door with an arched window above",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3ae9b6d5-6e35-4600-885b-d449f86c088f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06f-7320-70cc-90f5-7957eaaa939f.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and a chaise lounge. Hallway leads to closet.",
        "public_id": "019ee06f-7320-70cc-90f5-7957eaaa939f",
        "storage_key": "property/6767906449165633/019ee06f-7320-70cc-90f5-7957eaaa939f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace and a stylish chaise lounge. A hallway leads to a convenient closet space, showcasing the thoughtful layout of the apartment.",
      "link": "",
      "alt_text": "Living room with a fireplace and a chaise lounge. Hallway leads to closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f1bc99fe-7d35-4839-a834-05b8d3568e36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06f-453e-73dd-88dd-b91b27940d71.webp",
      "image_media": {
        "alt_text": "A beautifully made bed with striped linens in a bedroom with wood accents and a walk-in closet.",
        "public_id": "019ee06f-453e-73dd-88dd-b91b27940d71",
        "storage_key": "property/6767906449165633/019ee06f-453e-73dd-88dd-b91b27940d71.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush bed, elegant decor, and a spacious walk-in closet.",
      "link": "",
      "alt_text": "A beautifully made bed with striped linens in a bedroom with wood accents and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7eff3adb-944d-435c-99a9-7422c407f83a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06f-6606-7546-bead-e26b3f850b38.webp",
      "image_media": {
        "alt_text": "Modern bathroom with black and white chevron towels and decorative wall art.",
        "public_id": "019ee06f-6606-7546-bead-e26b3f850b38",
        "storage_key": "property/6767906449165633/019ee06f-6606-7546-bead-e26b3f850b38.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed bathroom featuring a stylish vanity, elegant decor, and ample space for relaxation. This apartment bathroom offers a perfect blend of comfort and modern design.",
      "link": "",
      "alt_text": "Modern bathroom with black and white chevron towels and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4da6bcf4-4a24-4518-8278-3eb5fe27da5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06f-5098-7309-934e-b3f8ae7e98fc.webp",
      "image_media": {
        "alt_text": "A furnished bedroom with a queen-size bed, nightstands, and a dresser.",
        "public_id": "019ee06f-5098-7309-934e-b3f8ae7e98fc",
        "storage_key": "property/6767906449165633/019ee06f-5098-7309-934e-b3f8ae7e98fc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully furnished bedroom, featuring a queen-size bed, stylish nightstands, and a spacious dresser. A large window floods the room with natural light.",
      "link": "",
      "alt_text": "A furnished bedroom with a queen-size bed, nightstands, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b51c473a-8b81-4524-836c-ae93ada3576a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06f-1eaa-720f-8418-69eb5b965069.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, fireplace, and TV.",
        "public_id": "019ee06f-1eaa-720f-8418-69eb5b965069",
        "storage_key": "property/6767906449165633/019ee06f-1eaa-720f-8418-69eb5b965069.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable seating, a coffee table, and entertainment center.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, coffee table, fireplace, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c3d6cde-63c6-4e50-8ca7-f963687a1366",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06f-12fb-76df-9845-d9fea4620cb7.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, granite countertops, stainless steel sink, white appliances, and decorative accents.",
        "public_id": "019ee06f-12fb-76df-9845-d9fea4620cb7",
        "storage_key": "property/6767906449165633/019ee06f-12fb-76df-9845-d9fea4620cb7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring ample cabinet space, granite countertops, and modern appliances, perfect for everyday cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, granite countertops, stainless steel sink, white appliances, and decorative accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a734edba-1836-443f-82a5-399c018136ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06f-0a9c-71cd-9bb2-cd3adeb89e1c.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with electrical panel.",
        "public_id": "019ee06f-0a9c-71cd-9bb2-cd3adeb89e1c",
        "storage_key": "property/6767906449165633/019ee06f-0a9c-71cd-9bb2-cd3adeb89e1c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit washer and dryer, complete with an accessible electrical panel.",
      "link": "",
      "alt_text": "In-unit washer and dryer with electrical panel.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e8cbbe17-0930-4209-9cce-100b5250c236",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06e-f5ae-74bc-8e19-a049ab8bffef.webp",
      "image_media": {
        "alt_text": "Dining area with a square table and four chairs",
        "public_id": "019ee06e-f5ae-74bc-8e19-a049ab8bffef",
        "storage_key": "property/6767906449165633/019ee06e-f5ae-74bc-8e19-a049ab8bffef.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals in this stylish dining area featuring a modern table and comfortable seating, perfect for intimate dinners or family gatherings.",
      "link": "",
      "alt_text": "Dining area with a square table and four chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c84c8e3a-66b6-428e-9997-716e6d90a94b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06e-fa0d-76aa-90b3-f83f317441b1.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white countertops, and black appliances.",
        "public_id": "019ee06e-fa0d-76aa-90b3-f83f317441b1",
        "storage_key": "property/6767906449165633/019ee06e-fa0d-76aa-90b3-f83f317441b1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring wooden cabinetry, granite-style countertops, and a complete suite of black appliances including a microwave, stove, and refrigerator.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, white countertops, and black appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_738f788a-ab70-48d6-9db1-d05bad717641",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06e-b3ee-705a-9a14-0b9edd5e8685.webp",
      "image_media": {
        "alt_text": "Gym with weight machines and treadmills",
        "public_id": "019ee06e-b3ee-705a-9a14-0b9edd5e8685",
        "storage_key": "property/6767906449165633/019ee06e-b3ee-705a-9a14-0b9edd5e8685.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Fully equipped fitness center with cardio machines and strength training equipment, perfect for your workout routine.",
      "link": "",
      "alt_text": "Gym with weight machines and treadmills",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_745ca344-47f3-4325-b52a-06c1f50fc0ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06e-e315-77a5-abd3-62a159fbb1e6.webp",
      "image_media": {
        "alt_text": "Dining area with a table and four chairs next to a kitchen.",
        "public_id": "019ee06e-e315-77a5-abd3-62a159fbb1e6",
        "storage_key": "property/6767906449165633/019ee06e-e315-77a5-abd3-62a159fbb1e6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A dining area with a table and four chairs, adjacent to a kitchen with wooden cabinets and appliances.",
      "link": "",
      "alt_text": "Dining area with a table and four chairs next to a kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_66221e0e-b176-4d5e-bdcc-6b9d5b8856ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06e-ad13-7554-910d-d5a4249e1972.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, weight bench, and free weights.",
        "public_id": "019ee06e-ad13-7554-910d-d5a4249e1972",
        "storage_key": "property/6767906449165633/019ee06e-ad13-7554-910d-d5a4249e1972.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, weight bench, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_67027f68-2873-4a9d-9a04-2ae0491aa5d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06e-8766-713f-ae0c-7ce7578c59d1.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and weight racks.",
        "public_id": "019ee06e-8766-713f-ae0c-7ce7578c59d1",
        "storage_key": "property/6767906449165633/019ee06e-8766-713f-ae0c-7ce7578c59d1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a variety of cardio machines and free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and weight racks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e79f376b-d9da-4247-90e9-389be75dd34d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06e-921f-70e8-8873-139d873cab74.webp",
      "image_media": {
        "alt_text": "Two plush blue armchairs in a lobby with a large window overlooking the exterior.",
        "public_id": "019ee06e-921f-70e8-8873-139d873cab74",
        "storage_key": "property/6767906449165633/019ee06e-921f-70e8-8873-139d873cab74.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in style in our beautifully designed lobby, featuring comfortable seating and large windows with scenic views.",
      "link": "",
      "alt_text": "Two plush blue armchairs in a lobby with a large window overlooking the exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0248669f-e083-4e73-8c5f-6a0789ef801f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06e-749d-77ea-9705-6b40311a70d8.webp",
      "image_media": {
        "alt_text": "Lobby with modern furniture and exposed wooden beams.",
        "public_id": "019ee06e-749d-77ea-9705-6b40311a70d8",
        "storage_key": "property/6767906449165633/019ee06e-749d-77ea-9705-6b40311a70d8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The stylish lobby features comfortable seating areas, modern decor, and an eye-catching exposed wooden beam ceiling, creating a welcoming ambiance for residents.",
      "link": "",
      "alt_text": "Lobby with modern furniture and exposed wooden beams.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2a363c2a-8876-41cb-8d62-7dd7afb7b178",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06e-0d91-7767-93f4-1e3fec01ce9e.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a fireplace, pink sofa, and view of the pool.",
        "public_id": "019ee06e-0d91-7767-93f4-1e3fec01ce9e",
        "storage_key": "property/6767906449165633/019ee06e-0d91-7767-93f4-1e3fec01ce9e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in style in our contemporary lounge, featuring a cozy fireplace, plush seating, and a beautiful view of the outdoor swimming pool.",
      "link": "",
      "alt_text": "Modern lounge area with a fireplace, pink sofa, and view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_14bbbd2d-5c49-4838-9a15-7fba745b95ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06e-14b9-73ef-a31b-90c7c01556ce.webp",
      "image_media": {
        "alt_text": "A spacious community lounge area with a fireplace, comfortable seating, and large windows.",
        "public_id": "019ee06e-14b9-73ef-a31b-90c7c01556ce",
        "storage_key": "property/6767906449165633/019ee06e-14b9-73ef-a31b-90c7c01556ce.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy fireplace and ample seating for residents.",
      "link": "",
      "alt_text": "A spacious community lounge area with a fireplace, comfortable seating, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd4960d9-350d-4186-ae28-d62db2e26afd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06d-dd3d-746f-85d9-c78906a595ee.webp",
      "image_media": {
        "alt_text": "Community kitchen area with island, seating, coffee station, and view of the pool.",
        "public_id": "019ee06d-dd3d-746f-85d9-c78906a595ee",
        "storage_key": "property/6767906449165633/019ee06d-dd3d-746f-85d9-c78906a595ee.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our community kitchen area, perfect for gatherings, featuring a coffee station and bar seating with a view of the sparkling pool.",
      "link": "",
      "alt_text": "Community kitchen area with island, seating, coffee station, and view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a03a0a33-54a4-4899-b699-ca18d9b1a1fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06b-a960-7518-b04e-6c430c57200f.webp",
      "image_media": {
        "alt_text": "Cozy living room with a fireplace, armchair, coffee table, and sliding glass doors with a view of trees.",
        "public_id": "019ee06b-a960-7518-b04e-6c430c57200f",
        "storage_key": "property/6767906449165633/019ee06b-a960-7518-b04e-6c430c57200f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this inviting living space featuring a warm fireplace, comfortable seating, and abundant natural light from the sliding glass doors.",
      "link": "",
      "alt_text": "Cozy living room with a fireplace, armchair, coffee table, and sliding glass doors with a view of trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d6e9d397-1bb6-40c2-9c7c-03015e94bd8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06b-9963-716a-9085-713619470aec.webp",
      "image_media": {
        "alt_text": "Staircase leading up from an entryway with a blue door and a decorative plant and books on a side table.",
        "public_id": "019ee06b-9963-716a-9085-713619470aec",
        "storage_key": "property/6767906449165633/019ee06b-9963-716a-9085-713619470aec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Welcome to your new home! Ascend the carpeted stairs from your entryway, greeted by tasteful decor and a touch of nature.",
      "link": "",
      "alt_text": "Staircase leading up from an entryway with a blue door and a decorative plant and books on a side table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b57b3c49-0185-4b13-b880-1bef7c951353",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06b-676d-7114-8011-69994a9e9e14.webp",
      "image_media": {
        "alt_text": "Kitchen featuring a stainless steel double sink, granite countertops, and wooden cabinets. A doorway leads to a bedroom.",
        "public_id": "019ee06b-676d-7114-8011-69994a9e9e14",
        "storage_key": "property/6767906449165633/019ee06b-676d-7114-8011-69994a9e9e14.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen with granite countertops, stainless steel sink, and ample cabinet space. Enjoy cooking and dining in this stylish space.",
      "link": "",
      "alt_text": "Kitchen featuring a stainless steel double sink, granite countertops, and wooden cabinets. A doorway leads to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_041b72c0-d4bd-4f66-b077-16d54570d151",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06b-950c-718e-8958-1f92a1e14355.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel sink, granite countertops, wooden cabinets, and white appliances.",
        "public_id": "019ee06b-950c-718e-8958-1f92a1e14355",
        "storage_key": "property/6767906449165633/019ee06b-950c-718e-8958-1f92a1e14355.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Apartment",
      "description": "View of a bright and clean kitchen featuring a double basin sink, ample counter space, and convenient appliance placement.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel sink, granite countertops, wooden cabinets, and white appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_96077e04-c24c-422e-bf3c-6ee496e73134",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06b-7d5d-7465-a120-19a29d90edff.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and a ceiling fan, with large windows overlooking greenery.",
        "public_id": "019ee06b-7d5d-7465-a120-19a29d90edff",
        "storage_key": "property/6767906449165633/019ee06b-7d5d-7465-a120-19a29d90edff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, accent armchair, and a stylish coffee table, perfect for relaxation and entertaining. Large windows provide ample natural light and scenic views.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, coffee table, and a ceiling fan, with large windows overlooking greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62bb564c-1254-4882-a6d5-612e6c20c0ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019ee06b-6765-70c3-907a-c0f0273248a6.webp",
      "image_media": {
        "alt_text": "A bedroom with a metal-frame bed, nightstand, and dresser.",
        "public_id": "019ee06b-6765-70c3-907a-c0f0273248a6",
        "storage_key": "property/6767906449165633/019ee06b-6765-70c3-907a-c0f0273248a6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, tasteful decor, and ample natural light from the large window.",
      "link": "",
      "alt_text": "A bedroom with a metal-frame bed, nightstand, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_8a7c3fbd-6114-4eeb-926f-27dd5e929b56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-8ce9-76ef-ad16-e6b1edaf675d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8ce9-76ef-ad16-e6b1edaf675d",
        "storage_key": "property/6767906449165633/019d2709-8ce9-76ef-ad16-e6b1edaf675d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-bf25-745c-a88c-b290cfeed7ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf25-745c-a88c-b290cfeed7ba",
        "storage_key": "property/6767906449165633/019d2709-bf25-745c-a88c-b290cfeed7ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_b4bf9e61-e807-4ad6-9cc1-1bee29d6b8f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-8cdc-7254-ad34-5832e0fdf986.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8cdc-7254-ad34-5832e0fdf986",
        "storage_key": "property/6767906449165633/019d2709-8cdc-7254-ad34-5832e0fdf986.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-bf25-745c-a88c-b290cfeed7ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf25-745c-a88c-b290cfeed7ba",
        "storage_key": "property/6767906449165633/019d2709-bf25-745c-a88c-b290cfeed7ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fb065b50-47cf-4085-a0af-358c1e07d282",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-8c2d-7717-aad5-24a9216c394d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8c2d-7717-aad5-24a9216c394d",
        "storage_key": "property/6767906449165633/019d2709-8c2d-7717-aad5-24a9216c394d.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-bf25-745c-a88c-b290cfeed7ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf25-745c-a88c-b290cfeed7ba",
        "storage_key": "property/6767906449165633/019d2709-bf25-745c-a88c-b290cfeed7ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_f4fd105e-ea97-4382-93a8-7078fb0a2e8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Popular fast-food chain specializing in chicken sandwiches and nuggets.",
      "poi_long_description": "People say this fast food restaurant serves fresh food. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-8c47-77fc-89e0-312243424b20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-8c47-77fc-89e0-312243424b20",
        "storage_key": "property/6767906449165633/019d2709-8c47-77fc-89e0-312243424b20.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-bf25-745c-a88c-b290cfeed7ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf25-745c-a88c-b290cfeed7ba",
        "storage_key": "property/6767906449165633/019d2709-bf25-745c-a88c-b290cfeed7ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_b8d634e6-1cc0-4eba-9ed3-4076c7a7cb2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-9168-7593-ab80-039a1433c34b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9168-7593-ab80-039a1433c34b",
        "storage_key": "property/6767906449165633/019d2709-9168-7593-ab80-039a1433c34b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-bf25-745c-a88c-b290cfeed7ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf25-745c-a88c-b290cfeed7ba",
        "storage_key": "property/6767906449165633/019d2709-bf25-745c-a88c-b290cfeed7ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f49d7322-b56b-4581-884e-d72b63822f18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-9117-74bb-a5f5-b1b6d558ad9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9117-74bb-a5f5-b1b6d558ad9f",
        "storage_key": "property/6767906449165633/019d2709-9117-74bb-a5f5-b1b6d558ad9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-bf28-7389-8640-c697c5b07cb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf28-7389-8640-c697c5b07cb4",
        "storage_key": "property/6767906449165633/019d2709-bf28-7389-8640-c697c5b07cb4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_7279e544-f49b-46d1-b52b-be1f15466d9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores with great deals and discounts. They highlight the clean, spacious, and welcoming atmosphere, as well as the convenient layout and ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-91d5-7308-b86c-68d22804ccd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-91d5-7308-b86c-68d22804ccd7",
        "storage_key": "property/6767906449165633/019d2709-91d5-7308-b86c-68d22804ccd7.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-bf28-7389-8640-c697c5b07cb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf28-7389-8640-c697c5b07cb4",
        "storage_key": "property/6767906449165633/019d2709-bf28-7389-8640-c697c5b07cb4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_5e9092dd-633c-43ee-a2ac-d6a404b1618c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-9211-73a8-ad5b-f6b00e6c2e11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9211-73a8-ad5b-f6b00e6c2e11",
        "storage_key": "property/6767906449165633/019d2709-9211-73a8-ad5b-f6b00e6c2e11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-beda-7055-a1f3-73e91442d4dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-beda-7055-a1f3-73e91442d4dc",
        "storage_key": "property/6767906449165633/019d2709-beda-7055-a1f3-73e91442d4dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0788e10d-e2a6-4015-9e44-6368523fc732",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Tulsa Hills Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7380 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Outdoor mall featuring Big Box stores alongside multiple restaurants and a movie theater.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and convenient stores. They highlight the convenient parking, easy access, and clean facilities. They also like the variety of businesses, including an emergency hospital and EV charging stations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-95f4-70fe-b934-09a326b1434b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-95f4-70fe-b934-09a326b1434b",
        "storage_key": "property/6767906449165633/019d2709-95f4-70fe-b934-09a326b1434b.webp",
        "width": 1280,
        "height": 1027
      },
      "poi_business_url": "http://www.shoptulsahills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185409236621719808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-hills-shopping-center",
      "poi_latitude": "36.0563227",
      "poi_longitude": "-96.0033215",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 214-979-3334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-bf28-7389-8640-c697c5b07cb4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-bf28-7389-8640-c697c5b07cb4",
        "storage_key": "property/6767906449165633/019d2709-bf28-7389-8640-c697c5b07cb4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5R7A_GeUtocRAPl5hIaPFTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_35cea061-bd42-4b7a-a449-37789e2a9807",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-9653-72e2-a3cd-c028194fb1cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9653-72e2-a3cd-c028194fb1cb",
        "storage_key": "property/6767906449165633/019d2709-9653-72e2-a3cd-c028194fb1cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-beda-7055-a1f3-73e91442d4dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-beda-7055-a1f3-73e91442d4dc",
        "storage_key": "property/6767906449165633/019d2709-beda-7055-a1f3-73e91442d4dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_01658a1d-2f23-4387-8a95-fdd08363a0cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-9772-726b-a148-2a4cd8dec26e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9772-726b-a148-2a4cd8dec26e",
        "storage_key": "property/6767906449165633/019d2709-9772-726b-a148-2a4cd8dec26e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-beb8-7601-bbe0-d595162ab9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-beb8-7601-bbe0-d595162ab9ff",
        "storage_key": "property/6767906449165633/019d2709-beb8-7601-bbe0-d595162ab9ff.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_030a0b2f-da3e-4d71-98ca-f76119637d6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-974d-739e-a362-e02af197b619.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-974d-739e-a362-e02af197b619",
        "storage_key": "property/6767906449165633/019d2709-974d-739e-a362-e02af197b619.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-beb8-7601-bbe0-d595162ab9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-beb8-7601-bbe0-d595162ab9ff",
        "storage_key": "property/6767906449165633/019d2709-beb8-7601-bbe0-d595162ab9ff.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f859c657-fbb4-47d2-b62e-106e9ed40fbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-9a0a-753b-bdb0-c317456df5be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9a0a-753b-bdb0-c317456df5be",
        "storage_key": "property/6767906449165633/019d2709-9a0a-753b-bdb0-c317456df5be.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-beb8-7601-bbe0-d595162ab9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-beb8-7601-bbe0-d595162ab9ff",
        "storage_key": "property/6767906449165633/019d2709-beb8-7601-bbe0-d595162ab9ff.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_01e4cdb8-e77d-456d-bc5c-1502025a5852",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-9c4b-737b-ad0b-d88cdf1a1f6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9c4b-737b-ad0b-d88cdf1a1f6e",
        "storage_key": "property/6767906449165633/019d2709-9c4b-737b-ad0b-d88cdf1a1f6e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-beb8-7601-bbe0-d595162ab9ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-beb8-7601-bbe0-d595162ab9ff",
        "storage_key": "property/6767906449165633/019d2709-beb8-7601-bbe0-d595162ab9ff.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_12b832ef-600a-42c9-a779-7347ad073a6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Relaxed aquarium with sharks, river otters, turtles and jellyfish.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-9bf5-7410-ad08-c1dca2d6444c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9bf5-7410-ad08-c1dca2d6444c",
        "storage_key": "property/6767906449165633/019d2709-9bf5-7410-ad08-c1dca2d6444c.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_4dbfeb26-0a4e-4247-a67d-4f763f7c282e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-9d44-74c3-8c60-e22e310e6f16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9d44-74c3-8c60-e22e310e6f16",
        "storage_key": "property/6767906449165633/019d2709-9d44-74c3-8c60-e22e310e6f16.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_5ddbb763-ba89-4459-a28a-cbf8fcba40d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Family-friendly chain featuring trampolines, climbing walls, ropes courses and other active recreational options.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-9f70-77ab-a87e-06d6cf89963e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-9f70-77ab-a87e-06d6cf89963e",
        "storage_key": "property/6767906449165633/019d2709-9f70-77ab-a87e-06d6cf89963e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_9b5ec743-4236-4ae6-bcae-5bb823fe9513",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Gravity-defying entertainment venue with state-of-the-art trampolines, plus dodgeball courts.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-a249-755a-9a70-cd20f6f461e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a249-755a-9a70-cd20f6f461e3",
        "storage_key": "property/6767906449165633/019d2709-a249-755a-9a70-cd20f6f461e3.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_92a362a9-fe7d-4637-b4a8-79b513e7d74c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5352 E Skelly Dr, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides, a basketball court, and a play area for younger children. They also highlight the friendly and helpful staff, and the clean and safe environment.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-a132-74d9-926a-db2a8ea56401.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a132-74d9-926a-db2a8ea56401",
        "storage_key": "property/6767906449165633/019d2709-a132-74d9-926a-db2a8ea56401.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324602171454774354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "36.0979811",
      "poi_longitude": "-95.9157069",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-818-7423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytTvJWTtocRUtyRW2DICas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_a60bd4d3-c920-463c-a530-f647e6a2cf81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-a1d3-729a-a8c5-43735a03b9d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a1d3-729a-a8c5-43735a03b9d9",
        "storage_key": "property/6767906449165633/019d2709-a1d3-729a-a8c5-43735a03b9d9.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cf5d63ae-7694-4bcd-9d67-07d827acfbf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-a508-7510-9f5f-222e9dbb4949.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a508-7510-9f5f-222e9dbb4949",
        "storage_key": "property/6767906449165633/019d2709-a508-7510-9f5f-222e9dbb4949.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2ed13c81-8af2-42a6-918c-440109c21344",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-a674-7358-8778-377f03dc20bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a674-7358-8778-377f03dc20bd",
        "storage_key": "property/6767906449165633/019d2709-a674-7358-8778-377f03dc20bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d8a3d911-5a7f-45ed-92b2-4c8970b1f9bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "Gym goers say this gym offers a clean and tidy facility with a welcoming and judgement-free atmosphere, and they appreciate the friendly and helpful staff. They also highlight the great price and smooth interaction with other members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-a660-75ba-9ab8-621bb3317083.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a660-75ba-9ab8-621bb3317083",
        "storage_key": "property/6767906449165633/019d2709-a660-75ba-9ab8-621bb3317083.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_56ff8af5-06ae-43b9-999e-bf9c0e8ac44c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Oklahoma Veterinary Specialists",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 West 78th Street South, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-a682-75b9-9428-9632ad88bddd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a682-75b9-9428-9632ad88bddd",
        "storage_key": "property/6767906449165633/019d2709-a682-75b9-9428-9632ad88bddd.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "http://okvets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5093478136724344104&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-veterinary-specialists",
      "poi_latitude": "36.0519175",
      "poi_longitude": "-96.0079484",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-299-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8o0AyeUtocRKE2sAmGrr0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_3ea8c94c-4ec1-443d-828f-1eb7d275ff31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "4915 E 41st St Suite A, Tulsa, OK 74135, USA",
      "poi_short_description": "Beauty retailer carrying a wide selection of products and offering salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-a9b7-756b-8ca3-eec706ba9eaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-a9b7-756b-8ca3-eec706ba9eaf",
        "storage_key": "property/6767906449165633/019d2709-a9b7-756b-8ca3-eec706ba9eaf.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-131",
      "poi_directions_map_url": "https://maps.google.com/?cid=10581466912609131404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.1058946",
      "poi_longitude": "-95.9208289",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-664-5916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeUzsceStocRjNudEBjs2JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_3591b948-46ef-41b7-8379-d96d78bcf492",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "4818 E 80th St Ste A, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, fitness classes, and amenities, including tanning, massage beds, and a sauna. They highlight the clean facilities, friendly staff, and welcoming atmosphere, with people from all walks of life enjoying their workouts. They also like the affordable prices and convenient 24-hour access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-aaa1-760b-9cd3-a8e3cdaa750c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-aaa1-760b-9cd3-a8e3cdaa750c",
        "storage_key": "property/6767906449165633/019d2709-aaa1-760b-9cd3-a8e3cdaa750c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://10gym.com/south-tulsa-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2406416433432823692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.047648",
      "poi_longitude": "-95.9239656",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-494-3644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-ITWKKTtocRjAdtGP9OZSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fa6993f0-929d-4e1f-821d-2ced1e9abfc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-ab69-716d-a773-46f8072e8db2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ab69-716d-a773-46f8072e8db2",
        "storage_key": "property/6767906449165633/019d2709-ab69-716d-a773-46f8072e8db2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2e5-74bc-8d98-9e05c88a311e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2e5-74bc-8d98-9e05c88a311e",
        "storage_key": "property/6767906449165633/019d2709-c2e5-74bc-8d98-9e05c88a311e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_9ab38e12-9a98-450c-8ece-aa817d954971",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-ab10-754f-83b1-4a7ba9c15351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ab10-754f-83b1-4a7ba9c15351",
        "storage_key": "property/6767906449165633/019d2709-ab10-754f-83b1-4a7ba9c15351.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2e5-74bc-8d98-9e05c88a311e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2e5-74bc-8d98-9e05c88a311e",
        "storage_key": "property/6767906449165633/019d2709-c2e5-74bc-8d98-9e05c88a311e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ce25c2f1-8298-487f-a86e-24b09994e79d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-adf4-7321-912c-9bdececbf897.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-adf4-7321-912c-9bdececbf897",
        "storage_key": "property/6767906449165633/019d2709-adf4-7321-912c-9bdececbf897.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2ec-74ab-98ab-ce10670bafeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2ec-74ab-98ab-ce10670bafeb",
        "storage_key": "property/6767906449165633/019d2709-c2ec-74ab-98ab-ce10670bafeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bad8e38a-1291-4f55-b8f6-7cd1c07feea6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-b00b-742d-bfcf-e43c34695479.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b00b-742d-bfcf-e43c34695479",
        "storage_key": "property/6767906449165633/019d2709-b00b-742d-bfcf-e43c34695479.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2ec-74ab-98ab-ce10670bafeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2ec-74ab-98ab-ce10670bafeb",
        "storage_key": "property/6767906449165633/019d2709-c2ec-74ab-98ab-ce10670bafeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e924ba36-95db-429f-a250-e33373107ce8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-afba-712c-be9d-a0c84590d35b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-afba-712c-be9d-a0c84590d35b",
        "storage_key": "property/6767906449165633/019d2709-afba-712c-be9d-a0c84590d35b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2ec-74ab-98ab-ce10670bafeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2ec-74ab-98ab-ce10670bafeb",
        "storage_key": "property/6767906449165633/019d2709-c2ec-74ab-98ab-ce10670bafeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6b493922-54af-454e-a783-22837c9cd8d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-b103-7307-85af-cc7460276e09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b103-7307-85af-cc7460276e09",
        "storage_key": "property/6767906449165633/019d2709-b103-7307-85af-cc7460276e09.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2ec-74ab-98ab-ce10670bafeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2ec-74ab-98ab-ce10670bafeb",
        "storage_key": "property/6767906449165633/019d2709-c2ec-74ab-98ab-ce10670bafeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d8996cfb-b381-4dbd-8076-c409d754052c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-b615-72ba-a412-774a53e24bd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b615-72ba-a412-774a53e24bd8",
        "storage_key": "property/6767906449165633/019d2709-b615-72ba-a412-774a53e24bd8.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2ec-74ab-98ab-ce10670bafeb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2ec-74ab-98ab-ce10670bafeb",
        "storage_key": "property/6767906449165633/019d2709-c2ec-74ab-98ab-ce10670bafeb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cb1adbb0-a353-476d-b3c2-b1bf6c1adbdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Tulsa Riverside Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8605 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-b4b5-708d-88ce-0041df4aeabe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b4b5-708d-88ce-0041df4aeabe",
        "storage_key": "property/6767906449165633/019d2709-b4b5-708d-88ce-0041df4aeabe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://flytulsa.com/tulsa-river-side/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10887194896589047936&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-riverside-airport",
      "poi_latitude": "36.0378532",
      "poi_longitude": "-95.9909439",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-299-5886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c344-73bb-9d8b-1c585110e02b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c344-73bb-9d8b-1c585110e02b",
        "storage_key": "property/6767906449165633/019d2709-c344-73bb-9d8b-1c585110e02b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJG-5WQAiUtocRgMiiWxMWF5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_caa383d5-d62e-4798-8fb8-03c2a63ea138",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Christiansen Aviation",
      "poi_type": "Transportation & Transit",
      "poi_address": "8767 S Jack Bates Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-b4b4-713c-bf5a-6853e5f4d3bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b4b4-713c-bf5a-6853e5f4d3bd",
        "storage_key": "property/6767906449165633/019d2709-b4b4-713c-bf5a-6853e5f4d3bd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://christiansenaviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11204997232924193680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christiansen-aviation",
      "poi_latitude": "36.0365935",
      "poi_longitude": "-95.9895957",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-299-2646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c344-73bb-9d8b-1c585110e02b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c344-73bb-9d8b-1c585110e02b",
        "storage_key": "property/6767906449165633/019d2709-c344-73bb-9d8b-1c585110e02b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SWkpQWUtocRkHOu4Z0lgJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_1657f531-6e3b-4c4b-b68e-0511ce12ff2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-b65e-7349-8bdf-346c00b146b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b65e-7349-8bdf-346c00b146b4",
        "storage_key": "property/6767906449165633/019d2709-b65e-7349-8bdf-346c00b146b4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_aae8e2f1-1caa-49f7-8439-9a559e31509a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-b90a-7277-bc57-d7fffe55c686.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b90a-7277-bc57-d7fffe55c686",
        "storage_key": "property/6767906449165633/019d2709-b90a-7277-bc57-d7fffe55c686.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_61cf0bd6-84fc-4b74-9726-1d61f30f2c9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-ba3c-7076-96be-1c7edc8b826d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ba3c-7076-96be-1c7edc8b826d",
        "storage_key": "property/6767906449165633/019d2709-ba3c-7076-96be-1c7edc8b826d.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c3fb7f80-5d87-4bf2-92b6-e515348660f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f0c350d7-4792-4bcd-b765-cf4cff67e87d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-bad0-7624-8ce1-4a5f0c0952b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bad0-7624-8ce1-4a5f0c0952b9",
        "storage_key": "property/6767906449165633/019d2709-bad0-7624-8ce1-4a5f0c0952b9.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-c2bb-703e-b79b-672f0ca1f60b",
        "storage_key": "property/6767906449165633/019d2709-c2bb-703e-b79b-672f0ca1f60b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1e12ff81-a0ed-46e4-8de2-b8afae800c32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Jenks East Elementary School",
      "poi_type": "Education",
      "poi_address": "8925 S Harvard Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.jenksps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7666529671605862805&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-east-elementary-school",
      "poi_latitude": "36.033814",
      "poi_longitude": "-95.9378796",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-0003-720b-a40f-ce3a9ff553d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-0003-720b-a40f-ce3a9ff553d6",
        "storage_key": "property/6767906449165633/019cfb4a-0003-720b-a40f-ce3a9ff553d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtXopIMyTtocRlUEPCB78ZGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d4e67015-e078-4710-b167-2364b32074ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Jenks East Intermediate",
      "poi_type": "Education",
      "poi_address": "3933 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jenksps.org/o/east-intermediate",
      "poi_directions_map_url": "https://maps.google.com/?cid=15765709535319936513&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-east-intermediate",
      "poi_latitude": "36.03378319999999",
      "poi_longitude": "-95.9326473",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-0003-720b-a40f-ce3a9ff553d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-0003-720b-a40f-ce3a9ff553d6",
        "storage_key": "property/6767906449165633/019cfb4a-0003-720b-a40f-ce3a9ff553d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy7xD5yiStocRAc67xEoNy9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_dad3e183-0b93-43c0-85c2-195746035fe4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Jenks Middle School",
      "poi_type": "Education",
      "poi_address": "3019 E 101st St S, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.jenksps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14101611830866602126&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-middle-school",
      "poi_latitude": "36.0187568",
      "poi_longitude": "-95.9426735",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-0003-720b-a40f-ce3a9ff553d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-0003-720b-a40f-ce3a9ff553d6",
        "storage_key": "property/6767906449165633/019cfb4a-0003-720b-a40f-ce3a9ff553d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJscJrOHiRtocRjug_Iz_9ssM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_819139b2-a608-4836-a9f1-6977a24abd0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Jenks High School",
      "poi_type": "Education",
      "poi_address": "205 E B St, Jenks, OK 74037, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-28b6-730f-bb84-ca28d45e5be0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-28b6-730f-bb84-ca28d45e5be0",
        "storage_key": "property/6767906449165633/019d7913-28b6-730f-bb84-ca28d45e5be0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jenksps.org/o/high-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=4896344340347075511&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-high-school",
      "poi_latitude": "36.0257108",
      "poi_longitude": "-95.9692903",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-0003-720b-a40f-ce3a9ff553d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-0003-720b-a40f-ce3a9ff553d6",
        "storage_key": "property/6767906449165633/019cfb4a-0003-720b-a40f-ce3a9ff553d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ5df6ViRtocRt7thUDxP80M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_da28e71c-0cc4-42bf-af01-ad09fbc3bb84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-2bdd-714c-8f20-f726c38066cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2bdd-714c-8f20-f726c38066cb",
        "storage_key": "property/6767906449165633/019d7913-2bdd-714c-8f20-f726c38066cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-0003-720b-a40f-ce3a9ff553d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-0003-720b-a40f-ce3a9ff553d6",
        "storage_key": "property/6767906449165633/019cfb4a-0003-720b-a40f-ce3a9ff553d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3a20d607-8195-4229-a416-6054f1e4499e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Spartan Collage Of Aeronautics and Technology - FLIGHT CAMPUS",
      "poi_type": "Education",
      "poi_address": "Tulsa, OK 74132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-2c17-733b-9670-0c13a2a4c621.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2c17-733b-9670-0c13a2a4c621",
        "storage_key": "property/6767906449165633/019d7913-2c17-733b-9670-0c13a2a4c621.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12725979814749809731&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "spartan-collage-of-aeronautics-and-technology-flight-campus",
      "poi_latitude": "36.0370357",
      "poi_longitude": "-95.989939",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-0003-720b-a40f-ce3a9ff553d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-0003-720b-a40f-ce3a9ff553d6",
        "storage_key": "property/6767906449165633/019cfb4a-0003-720b-a40f-ce3a9ff553d6.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv1O8kgWUtocRQyz0ZDfDm7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_10ae0938-261c-4fa9-ad16-3b0f878e159e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Louie's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "6310 E 101st St S, Tulsa, OK 74137, USA",
      "poi_short_description": "Casual hangout with sports on TV & a menu of classic American pub fare.",
      "poi_long_description": "Casual hangout with sports on TV & a menu of classic American pub fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-2cb9-73a1-a462-a3851ada5d90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2cb9-73a1-a462-a3851ada5d90",
        "storage_key": "property/6767906449165633/019d7913-2cb9-73a1-a462-a3851ada5d90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://louiesgrillandbar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1808828837458337944&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "louie-s-grill-bar",
      "poi_latitude": "36.016819",
      "poi_longitude": "-95.9054708",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-298-5777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-a0ee-70dd-84e9-e68a936d014a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-a0ee-70dd-84e9-e68a936d014a",
        "storage_key": "property/6767906449165633/019d7913-a0ee-70dd-84e9-e68a936d014a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu104XOSRtocRmOAvfD5AGhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_a73a8c48-3fd6-4e25-9399-f68af086f6c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Yokozuna Yale",
      "poi_type": "Restaurants",
      "poi_address": "9146 S Yale Ave #100, Tulsa, OK 74137, USA",
      "poi_short_description": "Modern eatery for creatively presented sushi, plus Asian-inspired dishes like fried rice.",
      "poi_long_description": "People say this sushi restaurant offers delicious miso soup and a flaming volcano roll. They also highlight the friendly and attentive service, and the positive and joyful vibe.\n\nSome reviews mention the sushi can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-2f73-732a-96ea-624bfe5fc35a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2f73-732a-96ea-624bfe5fc35a",
        "storage_key": "property/6767906449165633/019d7913-2f73-732a-96ea-624bfe5fc35a.webp",
        "width": 289,
        "height": 312
      },
      "poi_business_url": "http://www.yokozunasushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8849555864641643460&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "yokozuna-yale",
      "poi_latitude": "36.0298714",
      "poi_longitude": "-95.9233942",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-619-6271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff0-777c-a829-12bcd10804bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff0-777c-a829-12bcd10804bd",
        "storage_key": "property/6767906449165633/019cfb49-fff0-777c-a829-12bcd10804bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4hxYyCStocRxKPwAyzwz3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_93b9dbc6-3928-47a3-a27c-db58ebbd0b81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Brook South",
      "poi_type": "Restaurants",
      "poi_address": "7727 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly sports bar dishing up classics including burgers, sandwiches, soups & salads.",
      "poi_long_description": "People say this American restaurant serves generous portions of fish and chips, cheeseburgers, and chicken fried steak. They also highlight the friendly staff, reasonable prices, and pub-like atmosphere.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-318b-770e-9c99-51b987c5fd56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-318b-770e-9c99-51b987c5fd56",
        "storage_key": "property/6767906449165633/019d7913-318b-770e-9c99-51b987c5fd56.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.brookrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13481161506126313612&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "brook-south",
      "poi_latitude": "36.0323371",
      "poi_longitude": "-95.8887621",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-392-9977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff0-777c-a829-12bcd10804bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff0-777c-a829-12bcd10804bd",
        "storage_key": "property/6767906449165633/019cfb49-fff0-777c-a829-12bcd10804bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzx_i9weOtocRjDhUrPa0Frs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d3052c76-ea70-4699-b846-865a4173d0c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Oliveto Italian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "8922 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Local Italian chain serving pasta, pizza, sandwiches, classic entrees & wine in a stylish space.",
      "poi_long_description": "People say this Italian restaurant serves delicious chicken parmesan, pizza, and bruschetta. They also highlight the friendly staff and attentive service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-3359-777f-bddf-0efd7b9581d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3359-777f-bddf-0efd7b9581d9",
        "storage_key": "property/6767906449165633/019d7913-3359-777f-bddf-0efd7b9581d9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.olivetobistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5883500537200521972&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oliveto-italian-bistro",
      "poi_latitude": "36.034014",
      "poi_longitude": "-95.8871088",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-994-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff0-777c-a829-12bcd10804bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff0-777c-a829-12bcd10804bd",
        "storage_key": "property/6767906449165633/019cfb49-fff0-777c-a829-12bcd10804bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUw9-xuKNtocR9DKoA5FkplE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_6c86210a-f8ca-4205-b6dd-47ff807d4b46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Mandarin Taste",
      "poi_type": "Restaurants",
      "poi_address": "9107 S Sheridan Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed spot in a strip mall with made-to-order noodle soups, dumplings & other casual Chinese eats.",
      "poi_long_description": "People say this Chinese restaurant serves delicious traditional Sichuan dishes, such as Ma Po Tofu, pork belly, and Hong Kong barbecue buns, as well as interesting fish stews and Jade Fish Soup. They also highlight the large portions, good value, and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-3466-775f-8174-2d278b9d501d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3466-775f-8174-2d278b9d501d",
        "storage_key": "property/6767906449165633/019d7913-3466-775f-8174-2d278b9d501d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mandarintastetulsaok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11412740642181327613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mandarin-taste",
      "poi_latitude": "36.0314123",
      "poi_longitude": "-95.9037056",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-878-7998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff0-777c-a829-12bcd10804bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff0-777c-a829-12bcd10804bd",
        "storage_key": "property/6767906449165633/019cfb49-fff0-777c-a829-12bcd10804bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhWOCqYCStocR_arhkiUzYp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_784930e2-ab8f-44c4-a318-f039d9cb84b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "KEO",
      "poi_type": "Restaurants",
      "poi_address": "8921 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Upscale restaurant featuring Thai, Vietnamese, Cambodian and Malaysian dishes alongside a cocktail menu.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-3a38-77ac-8787-0d23a8d7fdf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3a38-77ac-8787-0d23a8d7fdf7",
        "storage_key": "property/6767906449165633/019d7913-3a38-77ac-8787-0d23a8d7fdf7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.keorestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16704805035880264240&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "keo",
      "poi_latitude": "36.0335201",
      "poi_longitude": "-95.9216006",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-794-0090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff0-777c-a829-12bcd10804bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff0-777c-a829-12bcd10804bd",
        "storage_key": "property/6767906449165633/019cfb49-fff0-777c-a829-12bcd10804bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnY79mCGStocRMLLMnaxj0-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_29a83d08-41c5-49a9-9fa2-045a53f7c255",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Ludger's Bavarian Cakery",
      "poi_type": "Restaurants",
      "poi_address": "6527 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Specialty wedding cake bakery with desserts including signature Bavarian cream cheesecake & coffee.",
      "poi_long_description": "People say this bakery offers delicious cakes, pastries, and sandwiches, with popular choices including the Bavarian cream cake, carrot cake, and key lime cake. They highlight the beautiful presentation of the cakes, the moist texture, and the flavorful fillings. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-39a5-77ef-9e97-4762228985e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-39a5-77ef-9e97-4762228985e2",
        "storage_key": "property/6767906449165633/019d7913-39a5-77ef-9e97-4762228985e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ludgersbavariancakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8360200812603105823&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ludger-s-bavarian-cakery",
      "poi_latitude": "36.0322251",
      "poi_longitude": "-95.9027009",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 918-622-2537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff0-777c-a829-12bcd10804bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff0-777c-a829-12bcd10804bd",
        "storage_key": "property/6767906449165633/019cfb49-fff0-777c-a829-12bcd10804bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBz7xmCGStocRH-IjRlhmBXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_4d4d9798-3d5b-4f0a-8781-cdb431ba21b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Scooter's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "8050 S Sheridan Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_long_description": "People say this coffee shop offers fresh coffee and mini donuts. They highlight the friendly staff and fast service. They also like the great drink options. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-3eba-77f1-b3c7-84f746feca16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3eba-77f1-b3c7-84f746feca16",
        "storage_key": "property/6767906449165633/019d7913-3eba-77f1-b3c7-84f746feca16.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://scooterscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15353783458659251733&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "scooter-s-coffee",
      "poi_latitude": "36.0467349",
      "poi_longitude": "-95.9047373",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 539-424-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-a136-774b-8eab-733347114cc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-a136-774b-8eab-733347114cc5",
        "storage_key": "property/6767906449165633/019d7913-a136-774b-8eab-733347114cc5.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJs0zh_0GTtocRFTanM7WYE9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_a3b53a7f-cd9f-4ebb-998b-de5ac180e58d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9136 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, organic, and healthy food options, including vegan, vegetarian, and paleo choices. They also highlight the clean and well-organized store, and the friendly and helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-499a-740b-8d7f-f4b39d9fd2f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-499a-740b-8d7f-f4b39d9fd2f2",
        "storage_key": "property/6767906449165633/019d7913-499a-740b-8d7f-f4b39d9fd2f2.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/yale?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690334156598386947&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.030638",
      "poi_longitude": "-95.9237179",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-879-0493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-0009-7055-a908-2f676889f008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-0009-7055-a908-2f676889f008",
        "storage_key": "property/6767906449165633/019cfb4a-0009-7055-a908-2f676889f008.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2KYkCCStocRA6HtoRBqF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_131b164c-e917-414a-9c4d-20fc5448a35f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "10019 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide range of products, including home goods, electronics, and groceries. They also highlight the clean store, efficient self-checkout, and helpful employees.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-4bfd-73ed-8484-150fa1ca2393.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4bfd-73ed-8484-150fa1ca2393",
        "storage_key": "property/6767906449165633/019d7913-4bfd-73ed-8484-150fa1ca2393.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/tulsa-south/2542",
      "poi_directions_map_url": "https://maps.google.com/?cid=16722350443478589485&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.0190344",
      "poi_longitude": "-95.8836409",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-615-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff3-75f8-ba68-c6f4fe7e3e73",
        "storage_key": "property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJC2SoWRCOtocRLSAjKSG5Eeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_aa79be52-acb0-46c9-804c-36fa74200f85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "10220 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "People say this warehouse store offers a wide variety of items, including bulk groceries, household goods, and unique international products. They highlight the affordable prices, especially on everyday essentials, and the incredible sales and discounts. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-4b89-770a-902a-8c391d7ae219.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4b89-770a-902a-8c391d7ae219",
        "storage_key": "property/6767906449165633/019d7913-4b89-770a-902a-8c391d7ae219.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/tulsa-OK-1207.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10676322776220458074&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "36.0148342",
      "poi_longitude": "-95.8892532",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-710-2220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff3-75f8-ba68-c6f4fe7e3e73",
        "storage_key": "property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRb4lRReOtocRWlwI2P_qKZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_cc5fd93e-cd1f-4eb5-8a12-2184c6d1e30b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "9595 S Delaware Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Shoppers say this department store offers great sales and has friendly, helpful staff. They also highlight the clean and well-organized store environment.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-4f42-70cb-8113-71b47b87e6ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4f42-70cb-8113-71b47b87e6ad",
        "storage_key": "property/6767906449165633/019d7913-4f42-70cb-8113-71b47b87e6ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/tulsa-426.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15941658097467013899&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "36.0256028",
      "poi_longitude": "-95.9474268",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-299-5073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff3-75f8-ba68-c6f4fe7e3e73",
        "storage_key": "property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYQuaYnCRtocRCztAvpMlPN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_2752abf4-74d5-4735-b15d-f4c6d9da6ac7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10111 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, and bulk foods, including organic and natural options. They also highlight the friendly and helpful staff, and the clean, well-organized shopping environment.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-58cb-75f7-8bfa-e49764122d74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-58cb-75f7-8bfa-e49764122d74",
        "storage_key": "property/6767906449165633/019d7913-58cb-75f7-8bfa-e49764122d74.webp",
        "width": 1280,
        "height": 1007
      },
      "poi_business_url": "https://sprouts.com/store/ok/tulsa/bixby",
      "poi_directions_map_url": "https://maps.google.com/?cid=4212849996008007892&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "36.01613340000001",
      "poi_longitude": "-95.8850383",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-364-7272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-0009-7055-a908-2f676889f008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-0009-7055-a908-2f676889f008",
        "storage_key": "property/6767906449165633/019cfb4a-0009-7055-a908-2f676889f008.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO2njyBCOtocR1CgQMMAMdzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7f73a154-4d8b-4097-99fc-a441139aaa8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "8207 E 103rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a wide selection of products, including imported foods, seasonal items, and chocolates. They highlight the good prices and the friendly, helpful staff. They also like the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-5876-7068-90a3-3c20219eea77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5876-7068-90a3-3c20219eea77",
        "storage_key": "property/6767906449165633/019d7913-5876-7068-90a3-3c20219eea77.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ok/tulsa/8207-e-103rd-street/f273",
      "poi_directions_map_url": "https://maps.google.com/?cid=1388118032718245033&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.014595",
      "poi_longitude": "-95.884268",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-0009-7055-a908-2f676889f008.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4a-0009-7055-a908-2f676889f008",
        "storage_key": "property/6767906449165633/019cfb4a-0009-7055-a908-2f676889f008.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk21FUVGOtocRqSx8Bv-VQxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_d0cfeb46-e60f-4b2b-8aab-c6f8ed43190f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Shoe Carnival",
      "poi_type": "Shopping & Retail",
      "poi_address": "9591 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Chain store selling a wide array of brand-name footwear for men, women & kids.",
      "poi_long_description": "Chain store selling a wide array of brand-name footwear for men, women & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-5c8f-7596-8aa1-e0634b29576b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5c8f-7596-8aa1-e0634b29576b",
        "storage_key": "property/6767906449165633/019d7913-5c8f-7596-8aa1-e0634b29576b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.shoecarnival.com/ok/tulsa/shoe-store-tulsa-ok-226.html?utm_source=google&utm_medium=listing&utm_content=226&utm_campaign=OK&utm_keyword=Tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12244530940666659590&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "shoe-carnival",
      "poi_latitude": "36.02637199999999",
      "poi_longitude": "-95.9478186",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-299-0369",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff3-75f8-ba68-c6f4fe7e3e73",
        "storage_key": "property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJO7zsYnCRtocRBkO3JwRQ7ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "custom_afab1142-f0fc-4912-9ef1-95e2c6abc457",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Petco",
      "poi_type": "Shopping & Retail",
      "poi_address": "9645 Riverside Pkwy # A, Tulsa, OK 74137, USA",
      "poi_short_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_long_description": "People say this pet store offers a large assortment of fish and supplies, as well as adorable kittens and budgies. They also highlight the helpful and friendly staff, and the clean and organized environment.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-65b9-7359-a99e-0497b3779b4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-65b9-7359-a99e-0497b3779b4d",
        "storage_key": "property/6767906449165633/019d7913-65b9-7359-a99e-0497b3779b4d.webp",
        "width": 1280,
        "height": 1023
      },
      "poi_business_url": "https://stores.petco.com/ok/tulsa/pet-supplies-tulsa-ok-1430.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3800786064116785059&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petco",
      "poi_latitude": "36.0244392",
      "poi_longitude": "-95.9482213",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-296-3312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff3-75f8-ba68-c6f4fe7e3e73",
        "storage_key": "property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJ0t_-HCRtocRo5_vsskavzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_store"
    },
    {
      "id": "custom_ff987538-e8b5-4ba7-bb1f-f3d2d2b04647",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10122 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "People say this department store offers a wide variety of specialty foods, kitchen appliances, and home decor. They also highlight the great deals, unique finds, and fun shopping experience.\n\nSome reviews mention the aisles can be narrow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-67eb-7199-ac00-23711323d5c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-67eb-7199-ac00-23711323d5c9",
        "storage_key": "property/6767906449165633/019d7913-67eb-7199-ac00-23711323d5c9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3972400949711173361&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "36.0161188",
      "poi_longitude": "-95.8885836",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-364-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff3-75f8-ba68-c6f4fe7e3e73",
        "storage_key": "property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOXYMBhqOtocR8Xb1-J3NIDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_67911e35-de19-424d-b2fe-8e7c0914f0af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "Utica Square Shopping Ctr, 1714 Utica Square, Tulsa, OK 74114, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-63eb-707e-912a-1c0ef0a50c30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-63eb-707e-912a-1c0ef0a50c30",
        "storage_key": "property/6767906449165633/019d7913-63eb-707e-912a-1c0ef0a50c30.webp",
        "width": 611,
        "height": 456
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1714+utica+sq-tulsa-ok-74114/id=15782",
      "poi_directions_map_url": "https://maps.google.com/?cid=17942462309257141615&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.1328599",
      "poi_longitude": "-95.9660751",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 918-743-9968",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fffc-70dd-a537-26f749c83d6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fffc-70dd-a537-26f749c83d6f",
        "storage_key": "property/6767906449165633/019cfb49-fffc-70dd-a537-26f749c83d6f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XYtKIDttocRb10bM2huAPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_05df3208-f5ce-4640-8f70-ec876e1a211d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "10938 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Expansive multi-department store stocking clothing, home furnishings, toys and electronics plus groceries.",
      "poi_long_description": "People say this department store offers a wide variety of products and has a convenient layout. They also highlight the clean and organized environment, and the fair prices.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-6752-722d-99da-d15f8770acd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6752-722d-99da-d15f8770acd0",
        "storage_key": "property/6767906449165633/019d7913-6752-722d-99da-d15f8770acd0.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1597-tulsa-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10170152242223552650&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.0046323",
      "poi_longitude": "-95.8894474",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-394-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff3-75f8-ba68-c6f4fe7e3e73",
        "storage_key": "property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJewC1ajuOtocRiphgnZSjI40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_04f03476-88a6-4ff2-bff4-f5ca2ddc8dc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Riverwalk Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "300 Riverwalk Terrace, Jenks, OK 74037, USA",
      "poi_short_description": "Lifestyle center on the Arkansas River and Muscogee (Creek) Nation reservation, with shopping, dining, live music, and a trail system.",
      "poi_long_description": "People say this shopping center offers a great selection of food and snacks, with many mentioning the Mexican grill. They also highlight the fun and peaceful atmosphere, beautiful scenery, and great service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-6cbf-75e0-aede-d9e4af93c4e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-6cbf-75e0-aede-d9e4af93c4e2",
        "storage_key": "property/6767906449165633/019d7913-6cbf-75e0-aede-d9e4af93c4e2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.jenksriverwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11784666382402635584&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "riverwalk-crossing",
      "poi_latitude": "36.0256838",
      "poi_longitude": "-95.95905820000002",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-518-6675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff3-75f8-ba68-c6f4fe7e3e73",
        "storage_key": "property/6767906449165633/019cfb49-fff3-75f8-ba68-c6f4fe7e3e73.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu9Z8JGCRtocRQMeYD6OLi6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_62b21737-c189-463c-9608-0f699271fcd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Hunter Park Pond",
      "poi_type": "Entertainment",
      "poi_address": "Creek Tumpike Trl, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2691387023598245280&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hunter-park-pond",
      "poi_latitude": "36.0293125",
      "poi_longitude": "-95.9110908",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff3-75f8-ba68-c83d535e53ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff3-75f8-ba68-c83d535e53ae",
        "storage_key": "property/6767906449165633/019cfb49-fff3-75f8-ba68-c83d535e53ae.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAufeRtocRoFWrBj26WSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0a8cddbb-8b16-4515-a003-fecaea24cfe2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Tulsa Zoo",
      "poi_type": "Entertainment",
      "poi_address": "6421 E 36th St N, Tulsa, OK 74115, USA",
      "poi_short_description": "An expansive, educational park with a huge variety of animals, plus the Safari Train & a carousel.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, sea lions, and tigers, and has a dinosaur exhibit, carousel, and playground. They highlight the membership is worth it, especially for large groups, and the zoo is family-friendly. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-710d-747a-93d6-7d08457ae43f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-710d-747a-93d6-7d08457ae43f",
        "storage_key": "property/6767906449165633/019d7913-710d-747a-93d6-7d08457ae43f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038979359347895889&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-zoo",
      "poi_latitude": "36.2130153",
      "poi_longitude": "-95.9064904",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "5 hours 1 min",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 918-669-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fffc-70dd-a537-26f749c83d6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fffc-70dd-a537-26f749c83d6f",
        "storage_key": "property/6767906449165633/019cfb49-fffc-70dd-a537-26f749c83d6f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjb_PwwXutocRUe5o3YmeUYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_5b5ef477-fe39-47e1-89d5-0796083ddcbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Philbrook Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2727 S Rockford Rd, Tulsa, OK 74114, USA",
      "poi_short_description": "Global collection of fine & decorative art in an ornate Italian Renaissance-style mansion & gardens.",
      "poi_long_description": "People say this museum offers a diverse collection of art, including traditional and modern pieces, and a beautiful Samurai exhibit. They highlight the stunning architecture, the well-maintained gardens and grounds, and the serene views. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-7462-7728-96ad-05abc04ebff9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-7462-7728-96ad-05abc04ebff9",
        "storage_key": "property/6767906449165633/019d7913-7462-7728-96ad-05abc04ebff9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.philbrook.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301074669923315730&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "philbrook-museum-of-art",
      "poi_latitude": "36.1238549",
      "poi_longitude": "-95.9700944",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 918-749-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-a458-727f-ab26-b3f9403f2ba1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-a458-727f-ab26-b3f9403f2ba1",
        "storage_key": "property/6767906449165633/019d7913-a458-727f-ab26-b3f9403f2ba1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VsvX7DstocRErAJ14RYDhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_cd0846d3-e2e7-4782-bd7c-631a542c690a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Gathering Place",
      "poi_type": "Entertainment",
      "poi_address": "2650 S John Williams Way, Tulsa, OK 74114, USA",
      "poi_short_description": "Riverfront park featuring an adventure playground, a sensory garden, a picnic area, eateries & more.",
      "poi_long_description": "People say this park offers a wide variety of activities, including playgrounds, water features, walking trails, and opportunities to feed fish. They highlight the beautiful, well-maintained grounds, the fun and interactive experiences for families, and the ample parking. They also like the availability of restrooms, food, and drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-8256-712c-bec1-203496551028.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8256-712c-bec1-203496551028",
        "storage_key": "property/6767906449165633/019d7913-8256-712c-bec1-203496551028.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatheringplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14222367875341211287&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gathering-place",
      "poi_latitude": "36.1251603",
      "poi_longitude": "-95.9840207",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 918-779-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fff3-75f8-ba68-c83d535e53ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fff3-75f8-ba68-c83d535e53ae",
        "storage_key": "property/6767906449165633/019cfb49-fff3-75f8-ba68-c83d535e53ae.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYnn1dDttocRl9ajsjoAYMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3077e712-6d81-4abd-bfdc-6fbf19706b32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "River Spirit Casino Resort",
      "poi_type": "Entertainment",
      "poi_address": "8330 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Riverside casino offering a steakhouse, casual eateries, table & electronic gaming, & weekend shows.",
      "poi_long_description": "People say this casino offers a wide variety of slot machines, live music, and entertainment venues, including a concert venue and a sports bar. They also highlight the clean and spacious rooms with beautiful views, the friendly and helpful staff, and the convenient amenities such as free valet parking and keyless check-in.\n\nOther reviews mention the machines can be tight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-84ab-755a-aa7c-eacff163082a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-84ab-755a-aa7c-eacff163082a",
        "storage_key": "property/6767906449165633/019d7913-84ab-755a-aa7c-eacff163082a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.riverspirittulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12292203165626239741&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-spirit-casino-resort",
      "poi_latitude": "36.0419162",
      "poi_longitude": "-95.9638914",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 888-748-3731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fffc-70dd-a537-26f749c83d6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fffc-70dd-a537-26f749c83d6f",
        "storage_key": "property/6767906449165633/019cfb49-fffc-70dd-a537-26f749c83d6f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJscNp2cGTtocR_YoV-qatlqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_2264cff9-4868-459d-bc67-45d105b69197",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Andy B's - Tulsa, OK",
      "poi_type": "Entertainment",
      "poi_address": "8711 S Lewis Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Family-friendly complex with bowling, laser tag, go-karts & games plus American eats & a pro shop.",
      "poi_long_description": "Visitors say this bowling alley offers a wide variety of entertainment options, including go-karts, laser tag, an arcade, and escape rooms. They also highlight the friendly and helpful staff, the clean environment, and the fun atmosphere for families and groups.\n\nSome reviews mention the wait times for go-karts can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-863f-748d-b171-81dbf4f54436.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-863f-748d-b171-81dbf4f54436",
        "storage_key": "property/6767906449165633/019d7913-863f-748d-b171-81dbf4f54436.webp",
        "width": 820,
        "height": 462
      },
      "poi_business_url": "https://bowlandybs.com/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=1068490842134744562&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "andy-b-s-tulsa-ok",
      "poi_latitude": "36.0379181",
      "poi_longitude": "-95.9540939",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-299-9494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-fffc-70dd-a537-26f749c83d6f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb49-fffc-70dd-a537-26f749c83d6f",
        "storage_key": "property/6767906449165633/019cfb49-fffc-70dd-a537-26f749c83d6f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx__1HtuTtocR8g0zg8IK1A4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_ee8624be-7470-4847-b46d-8afa59631a09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "B&B Theatres Tulsa Starworld 20",
      "poi_type": "Entertainment",
      "poi_address": "10301 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "People say this movie theater offers a fun selection of movies, comfortable seating, and a variety of snacks and drinks. They also highlight the friendly and competent staff, and the great movie experience, especially in the 4D theater.\n\nSome reviews mention the sound quality can be poor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-8a48-7053-9ee4-edebf7213ee4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8a48-7053-9ee4-edebf7213ee4",
        "storage_key": "property/6767906449165633/019d7913-8a48-7053-9ee4-edebf7213ee4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvb-b-and-b-tulsa-starworld-20/",
      "poi_directions_map_url": "https://maps.google.com/?cid=481928138472695873&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "b-b-theatres-tulsa-starworld-20",
      "poi_latitude": "36.0139263",
      "poi_longitude": "-95.8826249",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-710-3679",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019d7913-a33c-73fc-91ee-064b8659401d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-a33c-73fc-91ee-064b8659401d",
        "storage_key": "property/6767906449165633/019d7913-a33c-73fc-91ee-064b8659401d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0w_nJRSOtocRQSjurBYnsAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_3769405d-6db8-400d-b37b-7699a72c72f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Holland Hall (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "holland-hall-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_10862642-a304-491e-b580-b18fa7b26510",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Regent Preparatory School (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "regent-preparatory-school-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_428d0707-b605-4001-b16c-cf3d98606562",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "poi_name": "Bluestone Steakhouse and Seafood",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "bluestone-steakhouse-and-seafood",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_4741fdc0a1fb69705bb69607",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_88836dae736b7743f4d63a5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_95e23398bf9444d72ec1a8b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ba8b12727f0597e91ae8d188",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a216005f44c194972b3661d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_4825f76252ed508a7090ad31",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_04a62111-a6e4-4a59-aaf6-241c012a6e8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "rating": "5.0",
      "name": "Lydia Conroy",
      "text": "I moved in about a week ago and this is my first apartment so I don’t have a lot to go off of, but so far I’ve had a great experience. This apartment had everything I was looking for: safe area, low traffic, dog park, in unit washer and dryer, pet friendly, balcony, big windows, two story apartments, and decent pricing. The apartment was very clean when I moved in other than a few stains here and there. The staff has been very helpful and kind. They also did their best in getting an apartment close to my preferences while on the waiting list.\n\nSo far the neighborhood has been really quiet and kind. My only complaint about tenants is that they don’t pick up their dog poop in the dog park and I’m worried about my puppy getting sick.\n\nAs for maintenance, my A/C went out my second day here and I put ticket in. The next day the staff did a great job of informing me that there was a 24hr maintenance number and they would have fixed it that night. They were very kind and wanted to make sure I was taken care. They then got it fixed right away!",
      "date": "2024-06-16",
      "title": ""
    },
    {
      "id": "custom_7ba32f1e-ac0c-47f3-8f9b-54d33a02c5b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "rating": "5.0",
      "name": "Chris H",
      "text": "I am about to renew my lease at the Courtyards after one year of renting there. I doubt you will find much better apartments in Tulsa to live. This place is quiet, safe, located in a convenient part of town, and not quite as expensive as you would think. Kendra and Amber are outstanding in their customer service in the clubhouse. As well as the rest of the staff and crew employed by Case. Most of my maintenence requests have been completed in a timely and thorough manner. If you’re looking for a good place to rent in Tulsa, look no further.",
      "date": "2025-04-21",
      "title": ""
    },
    {
      "id": "custom_983a6f95-73b6-4d3e-b2dc-5d7c7b8f8cc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "rating": "5.0",
      "name": "Randy",
      "text": "Great staff, especially maintenance!\nThey do an outstanding job of responding to needs in a timely manner!",
      "date": "2025-10-10",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_00c98b7c-6a6a-4a09-9acd-43a5ed03b88a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb4a-8e5a-76df-80d5-fab0443fb493.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the building entrance and exterior.",
        "public_id": "019cfb4a-8e5a-76df-80d5-fab0443fb493",
        "storage_key": "property/6767906449165633/019cfb4a-8e5a-76df-80d5-fab0443fb493.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Courtyards of Tulsa Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f759de6706a5523cbb25df3"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-5f66-76d8-8f3c-723490bb67ca",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-courtyards",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633"
    },
    {
      "lead_collector_id": "019cf79e-5fd3-7528-b417-c1c2dda739aa",
      "lead_source": "LANDING_PAGE",
      "name": "the-courtyards",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-tulsa",
      "search_query": "apartments with in-unit laundry Tulsa",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Tulsa",
      "h2_subtitle": "Discover Tulsa apartments offering in-unit laundry. Enjoy the convenience at The Courtyards with modern amenities and comfortable living.",
      "page_copy": "At The Courtyards in South Tulsa, find the ultimate convenience in our apartments with in-unit laundry, designed to fit your lifestyle. Our spacious one and two-bedroom units ensure comfort and ease, while our modern amenities, such as a fitness center and a refreshing pool, enhance your daily living experience. Located in a vibrant neighborhood, The Courtyards is a perfect place to call home. \n\nEmbrace the benefits of having a washer and dryer right in your apartment, elevating your living standards without the hassle. Besides in-unit laundry, enjoy scenic walking and biking trails, perfect for leisurely strolls or energetic rides. Come visit The Courtyards today to experience a blend of practicality and relaxation in South Tulsa's finest living spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a beige sofa, blue coffee table, and fireplace.",
        "public_id": "019cfb49-de91-74ef-afe8-e0d2c232a75d",
        "storage_key": "property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tulsa Apartments with In-Unit Laundry",
      "seo_description": "Enjoy Tulsa living with in-unit laundry at The Courtyards. Spacious layouts and modern amenities await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-south-tulsa",
      "search_query": "air conditioned apartments South Tulsa",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in South Tulsa",
      "h2_subtitle": "Stay cool with South Tulsa apartments featuring air conditioning. The Courtyards offers comfort and style tailored to your needs.",
      "page_copy": "Beat the Oklahoma heat in style at The Courtyards, where air conditioned apartments in South Tulsa provide the ultimate comfort. Each unit is thoughtfully designed to keep you cool throughout the year, alongside a range of amenities that complete the perfect living environment. Whether you choose a one-bedroom or a two-bedroom layout, you'll enjoy a comfortable, well-cooled home. \n\nBeyond air conditioning, The Courtyards offers an ideal lifestyle with access to resort-style amenities such as a sparkling pool, modern fitness center, and inviting clubhouse. Stroll along the scenic walking and biking trails and embrace the vibrant South Tulsa community. Discover the blend of convenience and luxury that makes The Courtyards a premier living choice.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a beige sofa, blue coffee table, and fireplace.",
        "public_id": "019cfb49-de91-74ef-afe8-e0d2c232a75d",
        "storage_key": "property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in South Tulsa",
      "seo_description": "Find South Tulsa apartments with air conditioning at The Courtyards. Enjoy cool comfort with outstanding amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "generator",
      "page_item_url": "apartments-dishwasher-tulsa-ok",
      "search_query": "apartments with dishwasher in Tulsa OK",
      "category": "Amenity",
      "h1_title": "Tulsa Apartments with Dishwasher",
      "h2_subtitle": "Find Tulsa apartments equipped with a dishwasher. Experience easy living at The Courtyards with modern comforts.",
      "page_copy": "Make your daily routine effortless with Tulsa apartments that include a dishwasher at The Courtyards. Offering spacious one and two-bedroom layouts, each unit is equipped with contemporary features to enhance your living experience. Say goodbye to manual dishwashing and embrace the comfort and convenience The Courtyards provides. \n\nLocated in the heart of South Tulsa, The Courtyards combines modern living with resort-style amenities, such as a sparkling pool, fitness center, and picturesque walking trails. Our air-conditioned homes not only ensure that your chores are a breeze but also keep you comfortable year-round. Visit The Courtyards to discover how these features make life more convenient and enjoyable in Tulsa, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a beige sofa, blue coffee table, and fireplace.",
        "public_id": "019cfb49-de91-74ef-afe8-e0d2c232a75d",
        "storage_key": "property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tulsa OK Apartments with Dishwasher",
      "seo_description": "Discover apartments with a dishwasher in Tulsa, OK at The Courtyards. Enjoy modern conveniences and luxury living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "generator",
      "page_item_url": "luxury-apartments-pool-74133",
      "search_query": "luxury apartments with pool 74133",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in 74133",
      "h2_subtitle": "Enjoy luxury living in the 74133 area with a stunning pool. The Courtyards offers unparalleled amenities and stylish homes.",
      "page_copy": "Experience the epitome of luxury living at The Courtyards, where lush South Tulsa landscapes meet exquisite amenities. Situated in the 74133 zip code, our community features luxury apartments with access to a resort-style pool, perfect for relaxation and leisure activities. Whether enjoying a dip or lounging poolside, embrace the lifestyle you've been dreaming of. \n\nBeyond the stunning pool, The Courtyards offers spacious one and two-bedroom apartments finely crafted with luxurious finishes. The convenience continues with amenities like a state-of-the-art fitness center and serene walking trails, catering to your active and social needs. Explore how life at The Courtyards provides unmatched luxury and comfort in every detail.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a beige sofa, blue coffee table, and fireplace.",
        "public_id": "019cfb49-de91-74ef-afe8-e0d2c232a75d",
        "storage_key": "property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in the 74133 Area",
      "seo_description": "Live in 74133 luxury apartments with a pool at The Courtyards. Enjoy top-tier amenities and stunning surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-south-tulsa",
      "search_query": "fitness center apartments in South Tulsa",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments South Tulsa",
      "h2_subtitle": "Discover South Tulsa apartments with a modern fitness center. The Courtyards offers a lifestyle of health and convenience.",
      "page_copy": "Elevate your lifestyle at The Courtyards, where fitness enthusiasts find their perfect home in South Tulsa. Our apartments offer seamless access to a modern fitness center, equipped with everything you need to maintain an active lifestyle. Experience the convenience of working out within the comfort of your own apartment community, eliminating the need for external gym memberships.\n\nThe Courtyards not only provides a stellar fitness center but also ensures a holistic living experience with luxurious amenities. Choose from spacious one or two-bedroom layouts that promise comfort and style. With high-speed internet, picturesque walking trails, and a refreshing pool, our community in South Tulsa caters to a well-rounded, vibrant lifestyle. Discover the ultimate blend of health and comfort at The Courtyards today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a beige sofa, blue coffee table, and fireplace.",
        "public_id": "019cfb49-de91-74ef-afe8-e0d2c232a75d",
        "storage_key": "property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in South Tulsa",
      "seo_description": "Explore South Tulsa apartments with a fitness center at The Courtyards. Enjoy modern amenities and an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-tulsa",
      "search_query": "one bedroom apartments south tulsa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Find comfortable one bedroom apartments in South Tulsa. The Courtyards offers modern amenities and a vibrant community.",
      "page_copy": "Discover the ideal living space at The Courtyards, featuring one bedroom apartments in the heart of South Tulsa. Perfectly designed for those seeking convenience and comfort, our residences provide the perfect backdrop for personalized living. Each apartment includes modern amenities such as high-speed internet, in-unit washer/dryer, and a contemporary kitchen, making daily life effortless.\n\nOur community boasts an array of resort-style amenities, offering a blend of relaxation and recreation. Dive into the sparkling pool, stay active at the fitness center, or take leisurely strolls along the scenic walking trails. Located in South Tulsa, The Courtyards provides easy access to local attractions and daily conveniences. Make The Courtyards your new home and enjoy a vibrant lifestyle filled with both comfort and community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a beige sofa, blue coffee table, and fireplace.",
        "public_id": "019cfb49-de91-74ef-afe8-e0d2c232a75d",
        "storage_key": "property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in South Tulsa",
      "seo_description": "Explore one bedroom apartments in South Tulsa at The Courtyards. Enjoy modern living and vibrant community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165633",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-tulsa-oklahoma",
      "search_query": "two bedroom apartments tulsa ok",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Tulsa, OK",
      "h2_subtitle": "Explore spacious two bedroom apartments in Tulsa, OK. The Courtyards offers luxurious living with top-tier amenities.",
      "page_copy": "Welcome to The Courtyards, where spacious two bedroom apartments in Tulsa, OK, redefine modern living. Each unit is designed to offer ample space, ideal for families or individuals seeking extra room. With stylish finishes and thoughtful layouts, our apartments provide the perfect balance of comfort and elegance.\n\nThe Courtyards enhances your living experience with exceptional amenities. Residents can take advantage of our resort-style pool, state-of-the-art fitness center, and scenic walking trails. Located in the vibrant community of Tulsa, OK, our two bedroom apartments are not just homes, but the commencing point of a lifestyle full of convenience and leisure. Discover your new beginning at The Courtyards, where luxury meets practicality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a beige sofa, blue coffee table, and fireplace.",
        "public_id": "019cfb49-de91-74ef-afe8-e0d2c232a75d",
        "storage_key": "property/6767906449165633/019cfb49-de91-74ef-afe8-e0d2c232a75d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Tulsa, OK",
      "seo_description": "Discover two bedroom apartments in Tulsa, OK at The Courtyards. Enjoy spacious living with premier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5166"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-49RCWP1W4K"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151323"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/the-courtyards/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WPKL2XCD"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165633/019d1bda-41cf-746e-9799-67687434583c.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "1c360595-2614-4e8c-b8e4-a3b19277e55f"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-986-2260"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64418529e51607e58d576cba"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImRkZ0dlZ0V3azNrOHdBN3YzdFhmeXc9PSIsInZhbHVlIjoibEYvR0pXQVcvQzVJVXdJSkQxcnVpdz09IiwibWFjIjoiODFlOGY0YWEzODQ3ZjVkODdjZjY3OWYwYmM2ZWE1NmYxNzNiNmY4MTk5Y2ZiNmM5ZmViMDQwNzBmMWVlZDkzYiJ9"
    }
  ],
  "custom_qb_id": "5166",
  "custom_ga4_id": "G-49RCWP1W4K",
  "custom_repli_id": "10041151323",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/the-courtyards/register/",
  "custom_google_gtm_id": "GTM-WPKL2XCD",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165633/019d1bda-41cf-746e-9799-67687434583c.pdf",
  "custom_rentgrata_property_id": "1c360595-2614-4e8c-b8e4-a3b19277e55f",
  "custom_ppc_tracking_phone_number": "866-986-2260",
  "custom_residentboost_apartment_id": "64418529e51607e58d576cba",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImRkZ0dlZ0V3azNrOHdBN3YzdFhmeXc9PSIsInZhbHVlIjoibEYvR0pXQVcvQzVJVXdJSkQxcnVpdz09IiwibWFjIjoiODFlOGY0YWEzODQ3ZjVkODdjZjY3OWYwYmM2ZWE1NmYxNzNiNmY4MTk5Y2ZiNmM5ZmViMDQwNzBmMWVlZDkzYiJ9"
};

export const generatedAt = '2026-08-27T21:36:08.327Z';
